export const formatPrivateId = (id: string | null | undefined): string => {
  if (!id) return '—';
  const firstDash = id.indexOf('-');
  if (firstDash === -1) {
    return id;
  }
  const lastDash = id.lastIndexOf('-');
  if (lastDash <= firstDash) {
    return id;
  }
  const prefix = id.slice(0, firstDash);
  const suffix = id.slice(lastDash + 1);
  return `${prefix}...${suffix}`;
};
